var themeOptions = function (theme) { return ({
    components: {
        MuiTypography: {
            defaultProps: {
                variant: 'bodyLong1',
            },
            styleOverrides: {
                root: {
                    fontFamily: theme.typography.fontFamily,
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=typographyTheme.js.map